import React, {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import SimpleUploader from './SimpleUploader';

import {Divider, Layout, Table, Text} from '@phonectas/unifon-ui-kit';
import {BmoTicketById} from 'common/types/store/bmoTypes';
import CaseAttachmentsTableRow, {AttachmentsData} from './CaseAttachmentsTableRow';


interface CaseAttachmentsProps {
	data: BmoTicketById;
}

const CaseAttachments: React.FC<CaseAttachmentsProps> = ({data}) => {
	const [t] = useTranslation();
	const isFiles = data?.attachment?.length ? data?.attachment?.length > 0 : false;
	const attachments = useMemo(() => {
		return data?.attachment ?? [];
	}, [data]);

	const renderItem = useCallback((item: AttachmentsData, index: number) => {
		return (
			<CaseAttachmentsTableRow
				key={index}
				item={item}
				index={index}
			/>
		);
	}, []);

	return (
		<Layout fullWidth>
			<Layout direction="column" fullWidth>
				{
					!isFiles ? (
						<Layout fullWidth alignItems="center" justifyContent="center">
							<Text color="primary">
								{t('No attachments available')}
							</Text>
						</Layout>
					) : (
						<Table
							items={attachments}
							renderItem={renderItem}
							variant="compact"
						>
							<Table.Row>
								<Table.Cell>{t('Name')}</Table.Cell>
								<Table.Cell>{t('Sender')}</Table.Cell>
								<Table.Cell>{t('Date')}</Table.Cell>
							</Table.Row>
						</Table>
					)
				}
			</Layout>
			<Divider />
			{
				data?.id && (
					<SimpleUploader
						id={data.id}
						onUploadOk={true}
					/>
				)
			}
		</Layout>
	);
}

export default CaseAttachments;
